/* unplugin-vue-components disabled */import { render } from "./add-modal.vue?vue&type=template&id=692c75fa&scoped=true"
import script from "./add-modal.vue?vue&type=script&lang=js"
export * from "./add-modal.vue?vue&type=script&lang=js"

import "./add-modal.vue?vue&type=style&index=0&id=692c75fa&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692c75fa"],['__file',"src/pages/sh-topics/add-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "692c75fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('692c75fa', __exports__)) {
    api.reload('692c75fa', __exports__)
  }
  
  module.hot.accept("./add-modal.vue?vue&type=template&id=692c75fa&scoped=true", () => {
    api.rerender('692c75fa', render)
  })

}


export default __exports__